import styles from '@styles/components/sider.module.scss';
import { Link, matchPath, useLocation } from 'react-router-dom';
import NavAccessBadges from './NavAccessBadges';
import { Tab } from './tabs';

interface NavItemProps {
  tab: Tab;
  showAccess?: boolean;
}

const NavItem = (props: NavItemProps) => {
  const { tab, showAccess } = props;

  const { pathname } = useLocation();

  const isActive = matchPath(pathname, {
    path: tab.route,
    strict: false,
    exact: false,
  });

  return (
    <Link to={tab.route} className={`${styles.navItem} ${isActive ? styles.navItemActive : ''}`}>
      <div className={styles.icon}>{tab.icon}</div>
      <div className={`${styles.title} flex items-center`}>
        <span className="truncate">{tab.title}</span>
        {showAccess ? <NavAccessBadges access={tab.access} /> : null}
      </div>
    </Link>
  );
};

export default NavItem;
